import React, { useState } from "react";
import { Modal, Box, Typography, Divider, Button } from "@mui/material";

import { PayrunService } from "../../_service";
import { Notify, Utils } from "../../utils";
import { Constant } from "../../config";
import { useAppSelector } from "../../_app";
import { useDispatch } from "react-redux";
import { updateUserIntialState } from "../../_features";
import { ColorRing, } from "react-loader-spinner";
import CustomLoader from "../CustomLoader";
import moment from "moment";

interface CreatePayrunModalProps {
  open: boolean;
  handleClose: () => void;
  clearPreviousState: () => void;
  date: string;
  companyId: number;
  pendingCount: number;
  approvalHistoryId?: number;
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "4px",
  p: 2,
  border: "none",
  "&:focus": {
    outline: "none",
  },
};

const warning = {
  background: "#fff3cd",
  color: "#856404",
  padding: "10px 16px",
};

function CreatePayrunModal({
  open,
  handleClose,
  companyId,
  pendingCount,
  date,
  clearPreviousState,
  approvalHistoryId,
}: CreatePayrunModalProps) {
  const [checked, setChecked] = useState<boolean>(true);

  const [loading, setLoading] = useState<boolean>(false)

  const user = useAppSelector((state) => state.user);
  const dispatch = useDispatch();

  const handleCreatePayrun = async () => {
    setLoading(true);

    let payload = new FormData();
    if (approvalHistoryId) {
      payload.append("approval_history_id", approvalHistoryId.toString());
    }

    console.log("payload", approvalHistoryId, [...payload]);

    try {
      const { status, data } = await PayrunService._createPayrun(payload);
      if (status >= 200 && status < 300) {
        console.log("Payrun created successfully", data);
        setLoading(false);
        handleClose();
        // const { nextYear, nextMonth } = Utils.getNextMonthYear(
          //   user.current_payrun_date
        // );
        // const nextMonthDate = Utils.getLastDayOfMonth(nextYear, nextMonth);
        await dispatch(
          updateUserIntialState({
            ...user,
            current_payrun_date: data?.current_payrun_date,
          })
        );
        clearPreviousState();
      }
    } catch (error: any) {
      setLoading(false);
      handleClose();
      if (error?.response?.data?.Payrun) {
        Notify(error?.response?.data?.Payrun, 0);
      } else if (error?.response?.data?.payslip_date) {
        Notify(error?.response?.data?.payslip_date, 0);
      } else {
        Notify(Constant.common.something_went_wrong, 0);
      }
    }
    
  };

  let disabled = false;
  if (pendingCount > 0) {
    if (!checked) {
      disabled = true;
    } else {
      disabled = false;
    }
  } else {
    disabled = false;
  }
  return (
    <Modal
      open={open}
      onClose={handleClose}
      // aria-labelledby="modal-modal-title"
      // aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Create Pay Run: Monthly - {moment(date).format("DD/MM/YYYY")}
        </Typography>
        <Box sx={{ margin: "12px -16px" }}>
          <Divider light={true} />
        </Box>
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 2 }}>
          Ready to Create PayRun and Close the finalized payslips payroll?
        </Typography>
        {pendingCount > 0 && (
          <Box sx={warning}>
            <Typography sx={{ marginBottom: "14px" }}>
              Warning: There are 2 pending payslips that will be excluded from
              this pay run. If you confirm you will need to create another pay
              run later after finalising them.
            </Typography>
            <Box sx={{ display: "flex" }}>
              <input
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
                type="checkbox"
              />
              <Typography sx={{ marginLeft: "4px" }}>
                Continue without the pending payslips?
              </Typography>
            </Box>
          </Box>
        )}
        <Box sx={{ margin: "0 -16px 32px -16px" }}>
          <Divider light={true} />
        </Box>
        <Box sx={{ display: "flex", justifyContent: "end", marginTop: "16px" }}>
          <Box>
            <Button
              onClick={handleCreatePayrun}
              disabled={disabled || loading}
              variant="contained"
            >
              {loading && <CustomLoader />}
              Yes Create Pay Run
            </Button>
            <Button onClick={handleClose} sx={{ ml: 0.8 }}>
              NO-Stop
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export default CreatePayrunModal;
